<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="acc" slot-scope="prop">
        <ChooseBankcard
          :type="$route.query.type"
          :isRadio="true"
          v-model="prop.form.acc"
          @change="handleAccChange"
        />
      </section>
      <section slot="transferAmount" slot-scope="prop">{{prop.form.transferAmount}}</section>
      <!-- 验证码 -->
      <section slot="mesCode" slot-scope="prop">
        <el-input placeholder="请输入" class="inputBox" v-model="prop.form.mesCode">
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >{{smsTime || '获取短信验证码'}}</article>
        </el-input>
      </section>
      <!-- 验证码 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  platformAccountGetSms,
} from 'api/getPay';
import ChooseBankcard from 'components/choose/bankcard';
export default {
  components: {
    ChooseBankcard,
  },
  data () {
    return {
      smsTimer: null,
      smsTime: 0,
      otherFormData: {
        serialNo: '',
      },
      baseForm: {
        form: [
          {
            label: '账户名称',
            value: 'acc',
            default: {},
            slot: true,
          },
          {
            label: '转出账户',
            value: 'type',
            type: 'radio',
            default: 1,
            options: [
              {
                label: '收款账户(公户)',
                value: 1,
              },
              {
                label: '付款账户(公户)',
                value: 2,
              },
            ],
          },
          {
            label: '可转金额',
            value: 'transferAmount',
            slot: true,
            hide: true,
          },
          {
            label: '转移金额',
            value: 'amount',
            type: 'input',
          },
          {
            label: '验证码',
            value: 'mesCode',
            slot: true,
          },
        ],
        rules: {
          acc: [ // 账户名称
            { required: true, message: '请选择账户名称', trigger: 'blur' },
          ],
          amount: [ // 转移金额
            { required: true, message: '请输入转移金额', trigger: 'blur' },
          ],
          mesCode: [ // 验证码
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getSms () { // 获取短信验证码
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      const formData = await this.handleSubData(true);
      formData.amount = (formData.amount * 100).toFixed(2);
      if (formData.type === 1) { // 收款
        formData.accId = formData.receAcctId;
      } else { // 付款
        formData.accId = formData.payAcctId;
      }
      const res = await platformAccountGetSms({
        userType: 6,
        ...formData,
      });
      if (!res.failed) {
        this.otherFormData.serialNo = res;
        this.$message.success('验证码已发送，请可留意查收');
        clearInterval(this.smsTimer);
        this.smsTimer = setInterval(() => {
          this.smsTime--;
          if (this.smsTime <= 0) {
            this.smsTime = 0;
            clearInterval(this.smsTimer);
          }
        }, 1000);
      } else {
        this.smsTime = 0;
      }
    },
    handleAccChange () {
      const acc = this.$refs.baseForm.getVal('acc');
      this.$refs.baseForm.setVal('transferAmount', acc.bankBalance);
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['transferAmount'],
      });
    },
    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'SYS_STATE_DESC',
      });
      this.baseForm.stateOptions = enumsList[0];
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.accId = formData.acc.accId;
        formData.payAcctId = formData.acc.payAcctId;
        formData.receAcctId = formData.acc.receAcctId;
        formData.custName = formData.acc.custName;
        delete formData.acc;
        formData.serialNo = this.otherFormData.serialNo;
      }
      return formData;
    },

    setTypeOptionsAndDefaultValue () {
      let typeName = '';
      if (this.$route.query.type === 'public') {
        typeName = '(公户)';
      }
      if (this.$route.query.type === 'private') {
        typeName = '(私户)';
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'options',
        value: [
          { label: '收款账户' + typeName, value: 1 },
          { label: '付款账户' + typeName, value: 2 },
        ],
        names: ['type'],
      });
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.amount = (formData.amount * 100).toFixed(2);
        delete formData.transferAmount;
        delete formData.custName;
        if (formData.type === 1) { // 收款
          formData.accId = formData.receAcctId;
        } else { // 付款
          formData.accId = formData.payAcctId;
        }
        delete formData.receAcctId;
        delete formData.payAcctId;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (data.accId) {
        data.acc = {
          accId: data.accId,
          custName: data.custName,
          payAcctId: data.payAcctId,
          receAcctId: data.receAcctId,
        };
      } else {
        data.acc = {};
      }
      if (!data.type) {
        data.type = 1;
      }
      this.$refs.baseForm.setVal(data);
      this.setTypeOptionsAndDefaultValue();
    },
  },
};
</script>

<style scoped lang="scss">
.getCodeBtn {
  padding-right: 8px;
}
</style>
